import angular from 'angular';

let PaymentsFactory = angular.module('PaymentsFactory', [])
.factory('PaymentsFactory', ($rootScope, $http, HttpFactory, URLS) => {
	'ngInject';
	const PAYMENTS_RESOURCES = {
		TEAM : "team",
		PLAYER : "player",
	};
	return {
		PAYMENTS_RESOURCES: PAYMENTS_RESOURCES,
		getAll: (params) => {
			let parameters = Object.assign({}, params);
			return HttpFactory.get(URLS.PAYMENTS, parameters);
		},
		createPaymentItem: (data) => {
			/* data =>
			year_id
			name
			price
			comments
			required_team
			required_player
			*/
			return HttpFactory.post(URLS.PAYMENTS, data);
		},
		updatePaymentItem: (paymentId, data) => {
			/* data =>
			year_id
			name
			price
			comments
			required_team
			required_player
			*/
			return HttpFactory.put(URLS.PAYMENTS + "/" + paymentId, data);
		},
		deletePaymentItem: (paymentId) => {
			return HttpFactory.delete(URLS.PAYMENTS + "/" + paymentId);
		},
		getPayments: (resource, params) => {
			let url = HttpFactory.buildUrl(URLS.PAYMENTS_RESOURCE, {
				resource: resource
			});

			let parameters = Object.assign({ page_size: 2000 }, params);

			/* data =>
			payment_id
			player_id
			team_id
			dateFrom
			dateTo
			*/
			return HttpFactory.get(url, parameters);
		},
		addPayment: (resource, data) => {
			let url = HttpFactory.buildUrl(URLS.PAYMENTS_RESOURCE, {
				resource: resource
			});

			/* data =>
			payment_id
			player_id || team_id
			amount
			comments
			payment_at
			*/
			return HttpFactory.post(url, data);
		},
		updatePayment: (id, resource, data) => {
			let url = HttpFactory.buildUrl(URLS.PAYMENTS_RESOURCE, {
				resource: resource
			});
			url = url + "/" + id;
			return HttpFactory.put(url, data);
		},
		report: (resource, id) => {
			let url = HttpFactory.buildUrl(URLS.PAYMENTS_SINGLE_REPORT, {
				resource: resource,
				id: id
			});

			return HttpFactory.getPDF(url);
		},
		customReport: (resource, filters) => {
			let url = HttpFactory.buildUrl(URLS.PAYMENTS_CUSTOM_REPORT, {
				resource: resource
			});

			return HttpFactory.getPDF(url, filters);
		}
	};
}).name;

export default PaymentsFactory;



// WEBPACK FOOTER //
// ./client/app/services/payments.factory.js